import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="sticky top-0 z-50 bg-white shadow-md font-sans">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-900">CrossTax Advisors</h1>
        <div className="space-x-6">
          <Link to="/" className="text-gray-900 hover:text-accent transition">Home</Link>
          <Link to="/about" className="text-gray-900 hover:text-accent transition">About Us</Link>
          <Link to="/services" className="text-gray-900 hover:text-accent transition">Services</Link>
          <Link to="/insights" className="text-gray-900 hover:text-accent transition">Market Insights</Link>
          <Link to="/why-choose-us" className="text-gray-900 hover:text-accent transition">Why Choose Us</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
